import { Route } from "@/types/routes"

export const customerPortalRoute: Route = {
  isPublic: true,
  noAuthPage: true,
  shouldRedirect: ({ }) => false,
}
